const GuideCards = () => {
  const guides = [
    {
      icon: 'ri-user-heart-line',
      title: 'コミュニケーション能力',
      description: '専門用語を使わず、わかりやすく説明してくれる税理士を選びましょう。',
      points: [
        '質問に丁寧に答えてくれる',
        '定期的に連絡を取ってくれる',
        'レスポンスが早い',
        '経営者の立場で考えてくれる',
      ],
    },
    {
      icon: 'ri-lightbulb-line',
      title: '提案力・アドバイス力',
      description: '単なる記帳代行ではなく、経営改善の提案をしてくれる税理士が理想です。',
      points: [
        '節税対策の提案がある',
        '経営計画の策定支援',
        '資金繰りのアドバイス',
        '業界動向の情報提供',
      ],
    },
    {
      icon: 'ri-shield-check-line',
      title: '専門性と実績',
      description: 'あなたの業種や規模に合った経験と実績を持つ税理士を選びましょう。',
      points: [
        '同業種の顧問実績がある',
        '最新の税制に精通している',
        '補助金・助成金に詳しい',
        '相続・事業承継の知識',
      ],
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '料金の透明性',
      description: '料金体系が明確で、追加費用についても事前に説明してくれることが重要です。',
      points: [
        '料金表が明確',
        '追加費用の説明がある',
        'サービス内容が具体的',
        '見積もりが詳細',
      ],
    },
    {
      icon: 'ri-time-line',
      title: '対応のスピード',
      description: '緊急時にも迅速に対応してくれる税理士は、経営の強い味方になります。',
      points: [
        '電話・メールの返信が早い',
        '急な相談にも対応',
        '期限を守る',
        '訪問頻度が適切',
      ],
    },
    {
      icon: 'ri-team-line',
      title: 'チーム体制',
      description: '税理士一人ではなく、チームでサポートしてくれる事務所が安心です。',
      points: [
        '担当者が複数いる',
        'バックアップ体制がある',
        '専門分野の分担',
        '引継ぎがスムーズ',
      ],
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
            6つのチェックポイント
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            これらのポイントを確認して、あなたに最適な税理士を見つけましょう
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {guides.map((guide, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red/10 rounded-xl flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${guide.icon} text-2xl sm:text-3xl text-red`}></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {guide.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
                {guide.description}
              </p>
              <ul className="space-y-2 sm:space-y-3">
                {guide.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-2 sm:gap-3 text-sm sm:text-base text-gray-700">
                    <i className="ri-check-line text-red text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuideCards;
